import { CreateActionLayout } from './create/CreateActionLayout';
import { Toolbar } from './list/components/Toolbar';
import { TableLayout as ActionsTableLayout } from './list/TableLayout';

import type { PageHandleV2 } from '@/layouts/MainLayout/MainLayout.config';
import type { RouteObject } from 'react-router-dom';

export const actionsRoutes: RouteObject[] = [
	{
		path: 'actions',
		children: [
			{
				index: true,
				element: <ActionsTableLayout />,
				handle: {
					title: 'Actions',
					displayFilter: true,
					displaySearchFilter: true,
					displayTimeFilter: true,
					toolbar: Toolbar,
					actions: [
						{
							type: 'round-button',
							path: 'templates',
						},

						{
							type: 'button',
							title: 'New Action',
							path: 'actions/create',
						},
					],
				} satisfies PageHandleV2,
			},
			{
				path: 'create',
				element: <CreateActionLayout />,
				handle: {
					title: 'Actions',
					isChild: true,
					actions: [],
					displayFilter: false,
					displaySearchFilter: false,
					displayTimeFilter: false,
				} satisfies PageHandleV2,
			},
		],
	},
];
